import { tv } from "tailwind-variants";
const couponVariants = tv({
  slots: {
    applyButton: "text-b2 text-slate-400"
  },
  variants: {
    succeeded: {
      true: {
        applyButton: "text-slate-600"
      }
    }
  }
});
export {
  couponVariants as default
};
